<template>
    <div class="addBox relative">
      <div class="title">
        <div class="title_left"><span class="movePoin" @click="$router.go(-1)">规章制度</span>/<span class="type">{{$route.query.type=='add'?'新增':'编辑'}}</span></div>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
			<ToggleForm title="基本信息">
				<div class="content">
					<div class="row mt20">
						<el-form-item label="制度名称" prop="name">
							<el-input placeholder="请输入制度名称" class="w300" maxlength="30" v-model="form.name"></el-input>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="制度类型" prop="type">
              <el-input placeholder="请输入制度类型" class="w300" maxlength="30" v-model="form.type"></el-input>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="排序" prop="orderNum">
							<el-input placeholder="请输入排序序号, 1-1000内的整数" class="w300" maxlength="4" v-model="form.orderNum"></el-input>
						</el-form-item>
					</div>
					<div class="row rowybUpload">
              <el-form-item label="图片附件：">
                  <p class="rowybUploadText w500">上传图片大小不超过10M；上传格式：jpg、png、gif，最多上传5张图片。</p>
                  <ybUpload :maxLength=5 @uploadSuccess="getFiles" @uploadError="getFiles"
                      @remove="getFiles" :filesArr="filesArr"></ybUpload>
                      <!-- filesArr:[],回显的时候必传 -->
              </el-form-item>
          </div>
				</div>
			</ToggleForm>
      <ToggleForm title="制度内容">
        <div class="content wangeditor">
          <el-form-item label="制度内容：" prop="content">
            <wangeditor :isClear="isClear" :initVal="form.content" @change="ischange"></wangeditor>
          </el-form-item>
        </div>
			</ToggleForm>
		</el-form>
		<div class="foot-btn">
			<div>
			<el-button class="w70 mr10" @click="$router.go(-1)">取消</el-button>
			<el-button type="primary w70" :disabled="btn"  @click="submit(type)">保存</el-button>
			</div>
		</div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import ybUpload from "components/ybUpload";
import wangeditor from "components/wangeditor"
import * as api from "api/regulation";
export default {
  name: "personAdd",
  components: { 
      ToggleForm,
      ybUpload,
      wangeditor
  },
  data() {
    return {
      baseUrl: this.$store.state.common.baseUrl,
      btn: false,
      filesArr: [],
      type: '',
      rules: {
        name: [
          {
            required: true,
            message: '请输入制度名称, 30字以内',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请输入制度类型, 30字以内',
            trigger: 'blur'
          }
        ],
        orderNum: [
          {
            required: true,
            pattern: /^([1-9]\d{0,2}|1000)$/,
            message: '请输入排序序号, 1-1000内的整数',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入制度内容',
            trigger: 'blur'
          }
        ]
      },
      form: {
        name: '',
        type: '',
        orderNum: null,
        content: ''
      },
      picId: [],
      isClear: false
    };
  },
  methods: {
    ischange(val) {
      if(val === "<p><br></p>") {
        this.form.content = ''
      } else {
        this.form.content = val
      }
    },
    getFiles(files, state) {
      if(files.length === 0) {
        this.picId = []
      } else {
        let picId = []
        files.forEach(item => {
          picId.push(item.fileId)
        });
        this.picId = picId
      }
    },
    submit(type) {
      this.btn = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          let queryParams = {
            content: this.form.content,
            files: this.picId,
            id: type === 'edit' ? this.$route.query.id : '',
            name: this.form.name,
            orderNum: this.form.orderNum,
            type: this.form.type
          }
          let text = type == "add" ? "添加" : "编辑";
          this.$confirm("是否确认提交你的" + text + "？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let promise = type === 'add' ? 
            api.regulationAdd(queryParams) : 
            api.regulationEdit(queryParams)
            promise.then(res => {
              if (res.code == 200) {
                this.$message({
                  message: text+'成功!',
                  type: "success"
                });
                this.$router.push('/kitchenManage/regulation');
              } else {
              }
              this.btn = false;
            });
          }).catch(() => {
              this.$message({
                type: "info",
                message: "已取消" + text
              });
              this.btn = false;
            });
        } else {
          console.log("error submit!!");
          this.btn = false;
        }
      });
    },
    initData() { 
      Object.keys(this.form).forEach(key => this.form[key]= '')
      this.picId = []
      this.isClear = true
    },
    initEditData() {
      this.initData()
      api.regulationDetail({id: this.$route.query.id}).then(res => {
        if(res.code === 200) {
          let data = res.data
          let filesArr = []
          let picId = []
          this.form.content = data.content !== "<p><br></p>" ? data.content : ""
          this.form.name = data.name
          this.form.orderNum = data.orderNum
          this.form.type = data.type
          Object.keys(data.files).forEach(key => {
            filesArr.push({name: data.files[key].sourceName, fileId: data.files[key].fileId, url: this.baseUrl+'/'+data.files[key].fileUrl})
            picId.push(data.files[key].fileId)
          })
          this.filesArr = filesArr
          this.picId = picId
        }
      }).catch(err => {})
    }
  },
  mounted() {
    this.id = this.$route.query.id ? this.$route.query.id : ""
  },
  created() {
    this.type = this.$route.query.type
    if(this.type === 'add') { // 新增页
      this.initData();
    } else { // 编辑页
      this.initEditData()
    }
  }
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: calc(100% - 100px);
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
  .wangeditor {
    margin: 0 calc((100% - 986px) / 2);
    margin-top: 20px;
  }
}
</style>